import { BiSave } from "react-icons/bi";
import CxIcon from "../../cx/CxIcon";
import CxIconButtonNew from "../../cx/CxIconButtonNew";
import React from "react";
import { useTranslation } from "../../hx/useTranslation";
import CxState from "../../cx/CxState";
import CxSnackbar from "../../cx/CxSnackbar";
// eslint-disable-next-line
import * as FxLog from "../../fx/FxLog";
import * as FxFetch from "../../fx/FxFetch";
import "../../../styles/main.css";
import { getStoreValue, setStoreValue } from "../../gx/GxStore";
import GxForm from "../../gx/GxForm";

// Creado por Asistente de Programación - 2026-03-11
const MxPrefsUserForm = (props) => {
  const [{ trans }] = useTranslation();

  let rf_form = React.useRef(null);
  const rf_boShowTabs = React.useRef(null);
  const rf_SnackSave = React.useRef(null);

  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);

  const formLoad = async () => {
    let record = {};
    record['txScopeKey'] = "USER"; record['txScopeVal'] = getStoreValue('StoreSession', 'inUser');    
    Promise.all([FxFetch.doJsonX("sett/app/r", record)]).then((arResult) => {
      if (arResult[0]) {
        rf_boShowTabs.current?.setVal(arResult[0][0].boShowTabs);
      }
    });
  };

  const formSaveCustom = async () => {
    let filter = { "inUser": getStoreValue("StoreSession", "inUser") };
    let record = {};
    record['txScopeKey'] = "USER"; record['txScopeVal'] = getStoreValue('StoreSession', 'inUser');    
    
    record["boShowTabs"] = rf_boShowTabs.current.getVal();
    setStoreValue("StoreSession", "boShowTabs", rf_boShowTabs.current.getVal());

    Promise.all([FxFetch.doJsonF("sett/app/u", filter, record)]).then((arResult) => {
      if (arResult[0]) {
        if (arResult[0].theValue === "OK") {
          //forceUIUpdate(); // 2026-03-12 - daq: no funciona porque solo recarga la página actual.
          window.location.reload();
          rf_SnackSave.current.setOpen(true);
        }
      }
    });

    rf_SnackSave.current.setOpen(true);
  };

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.prefs')}-${trans('field.user')}`}
        xref={rf_form}
        addToolbarButtons={
          <div style={{ display: "flex", flexDirection: "row" }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} />} classType="ibsIconbuttonToolbar" onClick={() => formSaveCustom()} tooltip={trans("field.save")} />
          </div>
        }
      >
        <CxState mode="checkbox" xref={rf_boShowTabs} label={trans("field.prefs_show_tabs")} dbfield="boShowTabs" />
      </GxForm>

      <CxSnackbar xref={rf_SnackSave} severity="success" value={trans("msg.saved")} />
    </div>
  );
};

export default MxPrefsUserForm;